function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var TOOLTIP_BG = 'rgba(0,0,0,.75)';
var ARROW_TOP = {
  borderWidth: '0 5px 5px 5px',
  borderColor: "transparent transparent ".concat(TOOLTIP_BG, " transparent")
};
var ARROW_BOTTOM = {
  borderWidth: '5px 5px 0 5px',
  borderColor: "".concat(TOOLTIP_BG, " transparent transparent transparent")
};
var ARROW_LEFT = {
  borderWidth: '5px 5px 5px 0',
  borderColor: "transparent ".concat(TOOLTIP_BG, " transparent transparent")
};
var ARROW_RIGHT = {
  borderWidth: '5px 0 5px 5px',
  borderColor: "transparent transparent transparent ".concat(TOOLTIP_BG)
};
export default (function () {
  return {
    wrapper: {
      position: 'relative',
      display: 'inline-block',
      verticalAlign: 'middle'
    },
    elementWrapper: {
      cursor: 'pointer'
    },
    icon: {
      pointerEvents: 'none',
      transition: 'fill .2s'
    },
    tooltip: {
      fontSize: '13px',
      borderRadius: '3px',
      opacity: 0,
      transition: 'opacity 0.2s',
      padding: '10px',
      backgroundColor: TOOLTIP_BG,
      color: 'white',
      position: 'fixed',
      zIndex: 2,
      minWidth: '150px',
      maxWidth: '450px',
      pointerEvents: 'none',
      '&::after': {
        content: '""',
        display: 'block',
        position: 'absolute',
        borderStyle: 'solid',
        width: 0,
        height: 0
      }
    },
    tooltipContent: {
      position: 'relative'
    },
    tooltipLeft: {
      '&::after': _objectSpread({
        top: '50%',
        right: '-5px',
        transform: 'translateY(-50%)'
      }, ARROW_RIGHT)
    },
    tooltipRight: {
      '&::after': _objectSpread({
        top: '50%',
        left: '-5px',
        transform: 'translateY(-50%)'
      }, ARROW_LEFT)
    },
    tooltipRightBottom: {
      '&::after': _objectSpread({
        top: '-5px',
        left: '5px'
      }, ARROW_TOP)
    },
    tooltipCenterBottom: {
      '&::after': _objectSpread({
        top: '-5px',
        left: '50%',
        transform: 'translateX(-50%)'
      }, ARROW_TOP)
    },
    tooltipLeftBottom: {
      '&::after': _objectSpread({
        top: '-5px',
        right: '5px'
      }, ARROW_TOP)
    },
    tooltipRightTop: {
      '&::after': _objectSpread({
        bottom: '-5px',
        left: '5px'
      }, ARROW_BOTTOM)
    },
    tooltipCenterTop: {
      '&::after': _objectSpread({
        bottom: '-5px',
        left: '50%',
        transform: 'translateX(-50%)'
      }, ARROW_BOTTOM)
    },
    tooltipLeftTop: {
      '&::after': _objectSpread({
        bottom: '-5px',
        right: '5px'
      }, ARROW_BOTTOM)
    },
    hovered: {
      opacity: 1
    }
  };
});